





































import Vue, { PropOptions } from 'vue';
import { VueEditor } from 'vue2-editor';
import ProductSalesPageUploader from '@/web/components/products/sales-page/ProductSalesPageUploader.vue';

interface ProductIntroductionProps {
  value: PropOptions;
}

export default Vue.extend({
  name: 'ProductSalesPageIntroduction',
  components: { VueEditor, ProductSalesPageUploader },
  props: {
    value: {
      type: Object as () => ProductSalesPageIntroductionResponse,
    },
  } as ProductIntroductionProps,
  methods: {
    handleOnInput(key: string, value: any): void {
      const emitData = {
        ...this.value,
        [key]: value,
      };
      this.$emit('input', emitData);
    },
  },
});
